"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toSliderHeroSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var theme_colors_1 = require("../constants/theme-colors");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toSliderHeroSlice = function (data, logger) {
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.SliderHero)), { slides: data.items.map(function (slide) {
            return utils_1.compact({
                image: fields_1.toImage(slide.card_image, logger),
                title: fields_1.toText(slide.card_title),
                subtitle: fields_1.toText(slide.card_subtitle),
                link: fields_1.toLink(slide.card_cta_link, logger),
                label: fields_1.toText(slide.card_cta_label),
                themeColor: theme_colors_1.toThemeColor(slide.theme_color, logger)
            });
        }) }));
};
exports.toSliderHeroSlice = toSliderHeroSlice;
//# sourceMappingURL=slider-hero-slice.js.map